import { useEffect, useState } from "react";
import fetchAPI from "../../../../common/fetchAPI";
import { t } from "i18next";
import { ShowToast } from "../../../../common/Toastr";
import Loader from '../../../../common/Loader';
import { sortData,getValueFromResource } from '../../../../common/timeLiveFunction';
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import * as Sentry from "@sentry/react";

const initialSortValues = {
    sortOrder: 'asc',
    sortColumn: 'SystemEMailNotification'
}

const EmployeeEmailNotificationPreferences = (props: any) => {
    // const { AccountEmployeeId } = props;
    // Check if props is an empty object
    let { AccountEmployeeId } = props;
    const { sessionAccountEmployeeId } = useAppSelector((state) => state.globalState);
    // If props is empty, fallback to session
    if (Object.keys(props).length === 0 && AccountEmployeeId === undefined) {
        AccountEmployeeId = sessionAccountEmployeeId;
    }
    const [emailNotification, setemailNotification] = useState<any | ''>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isEmailVerified, setIsEmailVerified] = useState(false);
    const [clientSideSorting, setClientSideSorting] = useState<any | ''>(initialSortValues);
    // const [hoveredColumn, setHoveredColumn] = useState(null);
    const dispatch = useAppDispatch();
    useEffect(() => {
        renderEmailNotificationForEmployee();
    }, []);

    const renderEmailNotificationForEmployee = async () => {
        try {
            const response = await fetchAPI(`api/V2/EmailNotifications/AccountEMailNotificationPreferencessByAccountEmployeeId/${AccountEmployeeId}`, 'Get', '', true);
            const json = await response.json();
            //setemailNotification(JSON.parse(json.data));
            setemailNotification(sortData(JSON.parse(json.data), clientSideSorting.sortOrder, clientSideSorting.sortColumn));
            setIsEmailVerified(json.IsEmailVerified);
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
             Sentry.captureException(error);
        }
    }

    const onHandleChangeStatus = async (e: any, notificationObject: any) => {
        const { checked } = e.target;
        try {
            notificationObject.Enabled = checked ? true : false;
            const response = await fetchAPI("api/v2/EmailNotifications/UpdateAccountEMailNotificationPreference/" + isEmailVerified, "PUT", notificationObject, true, "");
            const json = await response.json();
            const index = emailNotification.findIndex((item: any) => item.AccountEMailNotificationPreferenceId === notificationObject.AccountEMailNotificationPreferenceId);
            const newArray = [...emailNotification];
            newArray[index].Enabled = checked ? true : false;
            json[0].StatusCode === "200" && setemailNotification(newArray);
            json[0].StatusCode === "200" ? ShowToast('Success', "Email Preferencess Update Successfully", "success", "toast-top-right") :
                ShowToast('Error', "Email Preferencess Update Failed", "error", "toast-top-right");
        } catch (error) {
            Sentry.captureException(error);
        }
    }

    // const handleMouseEnter = (columnIndex: any) => {
    //     setHoveredColumn(columnIndex);
    // }

    // const handleMouseLeave = () => {
    //     setHoveredColumn(null);
    // }

    const onHandleClientSideSorting = (sortOrder: string, sortColumn: string) => {
        setClientSideSorting({
            ...clientSideSorting,
            sortOrder: sortOrder,
            sortColumn: sortColumn
        });
        let sortedTeamResponse = [...emailNotification];
        setemailNotification(sortData(sortedTeamResponse, sortOrder, sortColumn));
    }

    return (
        <>
            {isLoading ?
                <Loader />
                :
                <div className="card card-custom admin-card">
                    <div className="card-header card-drop sticky-top fixed-top bg-white">
                        <h3 className="card-title fw-bold headerTitle">
                            {/* {t('Email Notification Preferences')} */}
                            {getValueFromResource('Email Notification Preferences',dispatch, t)}

                            </h3>
                    </div>
                    {/* <div className='card-body py-3'> */}
                    <div className="card-Report-body py-3">
                        <div className='table-responsive'>
                            <table className='table table-row-bordered table-bottom-color align-middle gs-1 gy-1 gx-1' style={{ width: '100%' }}>
                                <thead>
                                    <tr className='thHeading align-middle'>
                                        <th style={{ width: '80%' }}
                                        // onMouseEnter={() => handleMouseEnter(0)}
                                        // onMouseLeave={handleMouseLeave}
                                        >
                                            {/* {t("EMail Notification")} */}
                                            {getValueFromResource('EMail Notification',dispatch, t)}
                                            {clientSideSorting. sortColumn === 'SystemEMailNotification' ?
                                                clientSideSorting.sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "SystemEMailNotification") }}>
                                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "SystemEMailNotification") }}>
                                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                                </span>
                                                :
                                                // hoveredColumn === 0 && 
                                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "SystemEMailNotification") }}>
                                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                    </i>
                                                </span>
                                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "SystemEMailNotification") }}>
                                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                                            <span className="path1"></span>
                                                            <span className="path2"></span>
                                                        </i>
                                                    </span>
                                                </>}
                                        </th>
                                        <th style={{ width: '40%' }}>
                                            {/* {t("Active")} */}
                                            {getValueFromResource('Active',dispatch, t)}
                                            </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {emailNotification.length > 0 && emailNotification.map((item: any) => {
                                        return (
                                            <tr key={item.AccountEMailNotificationPreferenceId}>
                                                <td className="tdHeight">
                                                    <a className='text-dark d-block'>
                                                        {item.SystemEMailNotification}
                                                    </a>
                                                </td>
                                                <td className="tdHeight">
                                                    <div className="form-check form-switch form-check-custom">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input custom-padding-right h-15px w-30px"
                                                            checked={item.Enabled ? true : false}
                                                            onChange={(e) => {
                                                                onHandleChangeStatus(e, item)
                                                            }}
                                                            disabled={isEmailVerified ? false : true}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                            {emailNotification.length === 0 &&
                                <div className=''>
                                    <p className='noDataFound'>
                                        {/* {t('No Record Found')} */}
                                        {getValueFromResource('No Record Found',dispatch, t)}
                                        </p>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            }
        </>
    )
}
export default EmployeeEmailNotificationPreferences